import React,{useEffect} from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate,useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Update = () => {

    const { id } = useParams();
    const {readData} = useEntityCrud('Branch/GetBranch?BranchId=' + id);
    const {addData: updateData} = useEntityCrud('Branch/UpdateBranch');
    const navigate = useNavigate();

    const initialValues = {
        title: '',
        address: '',
        phone: ''
    };

    useEffect(() => {
        readData().then(({data}) => {
            if(data.status)
                formik.setValues({
                    ...data.result
                });
        });
    },[]);
    
    const validationSchema = Yup.object({
        title: Yup.string()
        .required(),
        address: Yup.string()
        .min(10,'طول آدرس وارد شده کوتاه است')
        .required(),
        phone: Yup.string()
        .test('phone', 'شماره تلفن وارد شده معتبر نمی باشد', value => {
            return value && /^\d+$/.test(value.toString().replace('-','')) && !value.startsWith('09') && value.length == 12;
        })
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            id,
            title: values.title,
            address: values.address,
            phone: values.phone
       };
       updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('به روزرسانی هلدینگ با موفقیت انجام شد');
                return navigate('/holding');
            }else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">ویرایش هلدینگ</div>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Update;